// extracted by mini-css-extract-plugin
export default {"container":"DialogPopupText_container__ppl13"};